import { LoanType, LoanTypeOptions } from '../../../../common/LoanConstants';

export const getDashboardLoanTypeName = (typeId: LoanType) => {
    if (typeId == LoanType.SubNoteConstruction) {
        return 'LOC';
    } else {
        const item = LoanTypeOptions.find((a) => {
            return a.id === typeId;
        });
        return item?.name ?? '';
    }
};
